define('view/people/trainings.list.page.view',['require','exports','module','uikit/uikit','backbone.radio','blockit','./people.left.nav','fukit/fukit','fukit/fukit'],function(require, exports, module) {
  //prettier-ignore
  var UIKit         = require('uikit/uikit'),
      Radio         = require('backbone.radio'),
      BlocKit       = require('blockit'),
      PeopleLeftNav = require('./people.left.nav'),
      RolesHelper   = require('fukit/fukit').RolesHelper,
      ROLES         = require('fukit/fukit').Roles;

  //behaviors
  // var AuthorizationBehavior              = require('behavior/authorization.behavior');

  // var ANY_PERSON_PROFILE_ROLE                 = [ROLES.PERSON_PROFILE_CREATE, ROLES.PERSON_PROFILE_READ, ROLES.PERSON_PROFILE_UPDATE, ROLES.PERSON_PROFILE_DELETE];
  // var ANY_RSADMIN_SETTINGS_CERTIFICATION_ROLE = [ROLES.RSADMIN_SETTINGS_CERTIFICATION_CREATE, ROLES.RSADMIN_SETTINGS_CERTIFICATION_READ, ROLES.RSADMIN_SETTINGS_CERTIFICATION_UPDATE, ROLES.RSADMIN_SETTINGS_CERTIFICATION_DELETE];
  // var ANY_PERSON_CERTIFICATION_ROLE           = [ROLES.PERSON_CERTIFICATION_CREATE, ROLES.PERSON_CERTIFICATION_READ, ROLES.PERSON_CERTIFICATION_UPDATE, ROLES.PERSON_CERTIFICATION_DELETE];
  // var ANY_INTERNAL_AFFILIATION_ROLE           = [ROLES.PERSON_INTERNAL_AFFILIATION_CREATE, ROLES.PERSON_INTERNAL_AFFILIATION_READ, ROLES.PERSON_INTERNAL_AFFILIATION_UPDATE, ROLES.PERSON_INTERNAL_AFFILIATION_DELETE];
  // var CREATE_UPDATE_OPTIONS = [
  //   {
  //     filter: function() {
  //       var state = Radio.request('AppKit.controllerService', 'state');
  //
  //       return state.get('authorizationMode') === 'create';
  //     },
  //     message: function() {
  //       var readOnly = RolesHelper.hasOnlyNamespacedRoles('PERSON_PROFILE_', ['READ']) && RolesHelper.hasOnlyNamespacedRoles('PERSON_PROFILE_', ['READ']) && RolesHelper.evaluateRoleArrayAgainstUserRoles(ANY_RSADMIN_SETTINGS_CERTIFICATION_ROLE);
  //
  //       return 'You do not have permission to edit this' + ((readOnly) ? ' page.' : '.');
  //     },
  //     roles: [
  //       [ROLES.PERSON_PROFILE_UPDATE],
  //       ANY_RSADMIN_SETTINGS_CERTIFICATION_ROLE,
  //       [ROLES.PERSON_CERTIFICATION_CREATE]
  //     ]
  //   },
  //   {
  //     filter: function() {
  //       var state = Radio.request('AppKit.controllerService', 'state');
  //
  //       return state.get('authorizationMode') === 'edit';
  //     },
  //     message: function() {
  //       var readOnly = RolesHelper.hasOnlyNamespacedRoles('PERSON_PROFILE_', ['READ']) && RolesHelper.hasOnlyNamespacedRoles('PERSON_PROFILE_', ['READ']) && RolesHelper.evaluateRoleArrayAgainstUserRoles(ANY_RSADMIN_SETTINGS_CERTIFICATION_ROLE);
  //
  //       return 'You do not have permission to edit this' + ((readOnly) ? ' page.' : '.');
  //     },
  //     roles: [
  //       [ROLES.PERSON_PROFILE_UPDATE],
  //       ANY_RSADMIN_SETTINGS_CERTIFICATION_ROLE,
  //       [ROLES.PERSON_CERTIFICATION_UPDATE]
  //     ]
  //   }
  // ]

  var TrainingsListPageView = BlocKit.ResolveOptionsView.extend({
    resolveOptions: {
      root: {
        type: BlocKit.TwoColumnLeftRailLayoutView,
        pageHeader: {
          headerText: 'My Profile',
          breadcrumbs: [
            {
              text: 'My Profile',
            },
            {
              text: '',
              route: 'profile:detail',
              behaviors: {
                updateCrumbWithPersonNameBehavior: {
                  behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                  optionValues: {
                    text: {
                      model: '@resources.person',
                      formatter: function(model) {
                        var userPrincipalModel = Radio.request(
                          'AppKit.resourceService',
                          'resource',
                          'userPrincipalModel'
                        );
                        var displayName = 'Current User';
                        var fullName = userPrincipalModel.get('fullName');
                        var username = userPrincipalModel.get('username');

                        displayName = model.get('fullName');
                        if (displayName.trim().length === 0) {
                          if (fullName && fullName.trim().length > 0) {
                            displayName = fullName;
                          } else if (username && username.length > 0) {
                            displayName = username;
                          }
                        }

                        return displayName;
                      },
                    },
                  },
                },
              },
            },
            {
              text: 'Trainings & Certifications',
            },
          ],
        },
        contentColumn: {
          components: [
            {
              type: BlocKit.AttachedComponentsContainerView,
              behaviors: {
                // AuthorizationBehavior: {
                //   visibleOnlyWhen: [
                //     {
                //       filter: function() {
                //         return true
                //       },
                //       message: 'You do not have permission to view this page.',
                //       roles: [
                //         ANY_PERSON_PROFILE_ROLE,
                //         ANY_RSADMIN_SETTINGS_CERTIFICATION_ROLE,
                //         ANY_PERSON_CERTIFICATION_ROLE
                //       ]
                //     }
                //   ],
                //   behaviorClass: AuthorizationBehavior
                // },
              },
              components: [
                {
                  type: BlocKit.ContentActionsHeaderView,
                  header: {
                    text: 'Trainings & Certifications',
                  },
                },
                {
                  type: BlocKit.BasicTableView,
                  collection: '@resources.trainings',
                  emptyText: 'No Trainings or Certifications.',
                  selectable: true,
                  columns: [
                    { text: 'Name', data: 'trainingType.name' },
                    {
                      text: 'Completion Date',
                      data: 'completionDate',
                      formatter: BlocKit.Formatter.date({ format: 'L', emptyValue: '--' }),
                    },
                    {
                      text: 'Expiration Date',
                      data: 'expirationDate',
                      formatter: BlocKit.Formatter.date({ format: 'L', emptyValue: '--' }),
                    },
                    {
                      text: 'Created',
                      data: 'createDate',
                      formatter: BlocKit.Formatter.date({ format: 'L', emptyValue: '--' }),
                    },
                  ],
                },
              ],
            },
          ],
        },
        railColumn: {
          components: [
            {
              type: PeopleLeftNav,
            },
          ],
        },
      },
    },
  });

  module.exports = TrainingsListPageView;
});

